import React, { forwardRef } from 'react';

const ExpandIcon = forwardRef((props, ref) => {
  const {
    style: { color },
    ...otherProps
  } = props;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={11}
      height={6}
      viewBox="0 0 11 6"
      fill="none"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.01889 5.76045L5.46088 5.18245L4.90286 5.76145C4.97486 5.83703 5.06148 5.89718 5.15744 5.93825C5.2534 5.97932 5.35671 6.00045 5.46109 6.00035C5.56547 6.00026 5.66873 5.97894 5.76462 5.9377C5.86051 5.89646 5.94703 5.83616 6.01889 5.76045ZM5.46088 4.02545L1.80887 0.240452C1.73685 0.164782 1.65024 0.104536 1.55423 0.0633698C1.45822 0.0222037 1.35483 0.000976562 1.25037 0.000976562C1.14591 0.000976562 1.04254 0.0222037 0.946533 0.0633698C0.850526 0.104536 0.763879 0.164782 0.691864 0.240452C0.543585 0.39656 0.460938 0.603647 0.460938 0.818953C0.460938 1.03426 0.543585 1.24134 0.691864 1.39745L4.90286 5.76145L5.46088 5.18245L6.01889 5.76145L10.2299 1.39745C10.3782 1.24134 10.4608 1.03426 10.4608 0.818953C10.4608 0.603647 10.3782 0.39656 10.2299 0.240452C10.1579 0.164782 10.0712 0.104536 9.97522 0.0633698C9.87921 0.0222037 9.77585 0.000976562 9.67139 0.000976562C9.56693 0.000976562 9.46353 0.0222037 9.36752 0.0633698C9.27152 0.104536 9.1849 0.164782 9.11288 0.240452L5.46088 4.02545Z"
        fill={color}
      />
    </svg>
  );
});

ExpandIcon.defaultProps = {
  style: {
    color: '#454545',
  },
};

export default ExpandIcon;
